<template>
  <q-card flat bordered>
    <div id="intercom-header" class="q-pa-md flex justify-between q-gutter-y-sm">
      <div>
        <div class="text-h6">Concessions</div>
        <div style="font-size: 12px">
          Compare concessions offered by your subject property to what the market is offering.
        </div>
      </div>
      <div id="intercom-concessions-actions" class="flex q-gutter-sm" data-html2canvas-ignore>
        <q-btn flat no-caps class="q-my-auto" @click="exportCSV">
          <q-icon name="download" class="q-mr-sm" size="medium" />Download
        </q-btn>
        <q-select
          v-model="status"
          transition-duration="100"
          style="width: 150px"
          dense
          outlined
          label="Metric"
          :options="statusOptions"
          @update:model-value="
            (filter) => $tracker.changedFilter('concession_status', 'concessions', filter)
          "
        />
      </div>
    </div>
    <concessions-table
      id="intercom-concessions-content"
      ref="concessionsTable"
      :concessions="rows"
      :date-range="dateRange"
      :default-status="defaultStatus"
      :printing-mode="printingMode"
    />
  </q-card>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { PropertyDetailsResponse, Availability, Price, AvailabilityPeriod } from 'common'
import ConcessionsTable from '@/components/PropertyReports/ConcessionsTable.vue'

export default {
  name: 'PropertyCompareConcessions',
  components: { ConcessionsTable },
  props: {
    filteredProperties: {
      type: Array<{
        prop: PropertyDetailsResponse
        units: {
          unit: Availability
          lastHistory: Price
          period: AvailabilityPeriod
        }[]
      }>,
      required: true
    },
    dateRange: {
      type: Object as PropType<{ from: Date; to: Date }>,
      required: true
    },
    defaultStatus: {
      type: String,
      default: 'active'
    },
    printingMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: { value: 'active', label: 'Active' } as { value: string; label: string },
      statusOptions: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Expired' },
        { value: 'all', label: 'All' }
      ]
    }
  },
  computed: {
    rows() {
      return this.filteredProperties.flatMap(({ prop }) => {
        let activeConcessions = prop.concessions_history || []
        if (this.status.value === 'active') {
          activeConcessions = activeConcessions.filter(
            (concession) => concession.to_date >= prop.created_on
          )
        } else if (this.status.value === 'inactive') {
          activeConcessions = activeConcessions.filter(
            (concession) => concession.to_date !== prop.created_on
          )
        }
        return activeConcessions.map((c) => ({ prop, concession: c }))
      })
    }
  },
  created() {
    this.status = this.statusOptions.find((_) => _.value === this.defaultStatus)!
  },
  methods: {
    exportCSV() {
      // call export CSV frm concessionsTable component
      this.$refs.concessionsTable.exportCSV()
    }
  }
}
</script>
